export interface Finish {
  id: 'white' | 'silver' | 'gold' | 'black';
  label: string;
  image: string;
  swatchClassName: string;
}

export const FINISHES: Finish[] = [
  {
    id: 'white',
    label: 'Alpine White',
    image: '/assets/goldie/white.jpg',
    swatchClassName: 'bg-[#F5F3ED]',
  },
  {
    id: 'silver',
    label: 'Brushed Nickel',
    image: '/assets/goldie/silver.jpg',
    swatchClassName: 'bg-gradient-to-br from-[#D9DEE3] to-[#9BA6AF]',
  },
  {
    id: 'gold',
    label: 'Satin Brass',
    image: '/assets/goldie/gold.jpg',
    swatchClassName: 'bg-gradient-to-br from-[#E7C27A] to-[#9C7A2E]',
  },
  {
    id: 'black',
    label: 'Matte Black',
    image: '/assets/goldie/black.jpg',
    swatchClassName: 'bg-gradient-to-br from-[#3B3B3D] to-[#111113]',
  },
];
